module.exports = __webpack_public_path__ + "static/media/33-15.5bf9ea1d.mp3";